/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Approvals_LabelInputs */

const en_style_guide_manager_approvals_label = /** @type {(inputs: Style_Guide_Manager_Approvals_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvals`)
};

const fr_style_guide_manager_approvals_label = /** @type {(inputs: Style_Guide_Manager_Approvals_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approbations`)
};

const de_style_guide_manager_approvals_label = /** @type {(inputs: Style_Guide_Manager_Approvals_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigungen`)
};

const it_style_guide_manager_approvals_label = /** @type {(inputs: Style_Guide_Manager_Approvals_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvazioni`)
};

const ru_style_guide_manager_approvals_label = /** @type {(inputs: Style_Guide_Manager_Approvals_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Утверждения`)
};

const es_style_guide_manager_approvals_label = /** @type {(inputs: Style_Guide_Manager_Approvals_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobaciones`)
};

const zh_cn2_style_guide_manager_approvals_label = /** @type {(inputs: Style_Guide_Manager_Approvals_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审批`)
};

const ja_style_guide_manager_approvals_label = /** @type {(inputs: Style_Guide_Manager_Approvals_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認`)
};

const hi_style_guide_manager_approvals_label = /** @type {(inputs: Style_Guide_Manager_Approvals_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वीकृति`)
};

const pt_pt2_style_guide_manager_approvals_label = /** @type {(inputs: Style_Guide_Manager_Approvals_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovações`)
};

/**
* | output |
* | --- |
* | "Approvals" |
*
* @param {Style_Guide_Manager_Approvals_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_approvals_label = /** @type {((inputs?: Style_Guide_Manager_Approvals_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Approvals_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_approvals_label(inputs)
	if (locale === "de") return de_style_guide_manager_approvals_label(inputs)
	if (locale === "it") return it_style_guide_manager_approvals_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_approvals_label(inputs)
	if (locale === "es") return es_style_guide_manager_approvals_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_approvals_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_approvals_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_approvals_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_approvals_label(inputs)
	return en_style_guide_manager_approvals_label(inputs)
});